// packages/world-model/src/traits/acoustic/index.ts

export { AcousticTrait, ACOUSTIC_TIER_COSTS, type AcousticTier } from './acousticTrait';
export { AcousticDampenerTrait } from './acousticDampenerTrait';
